import React, { useRef, useState } from 'react'

import { AcornsIcon } from '@acorns/icons'
import { Subheading } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'
import styled from 'styled-components'

import { Footer } from 'components/SidebarFrame/Footer'
import theme from 'theme'

const FooterSection = styled.div`
  max-width: 1320px;
  padding: 30px;
  margin-left: auto;
  margin-right: auto;

  @media screen and (min-width: ${theme.breakpoints.md + 1}px) {
    padding: 50px 60px;
  }

  @media screen and (max-width: ${theme.breakpoints.md}px) {
    max-width: 100%;
    padding: 30px;
    background: ${theme.colors.white};
    margin-bottom: 10px;
  }
`

const OuterContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  height: 22px;
`

const DisclosuresDropdown = styled(Subheading)`
  justify-content: flex-end;
  vertical-align: top;
  text-align: left;
  display: flex;
  align-items: center;
  margin-left: auto;
  cursor: pointer;
`

const Arrow = styled(AcornsIcon)<{ isOpen: boolean }>`
  width: 10px;
  height: auto;
  margin-left: 5px;
  path {
    &[stroke] {
      stroke: ${(props) => props.theme.colors.stoneLight};
    }
  }
  transition: all 300ms ease-in-out;
  transform: ${(props) => (props.isOpen ? 'rotate(0)' : 'rotate(180deg)')};
`

const Disclosures = styled.div<{ isOpen: boolean }>`
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  margin-top: ${(props) => (props.isOpen ? '50px' : '0px')};
  opacity: ${(props) => (props.isOpen ? '1' : '0')};
  overflow: hidden;
  max-height: ${(props) => (props.isOpen ? '1000px' : '0px')};
  transition: all 300ms ease-in-out;
  color: ${(props) => props.theme.colors.stone};
  @media screen and (max-width: ${theme.breakpoints.md}px) {
    margin-top: ${(props) => (props.isOpen ? '30px' : '0px')};
  }
`

const DISCLOSURES_OPEN_DELAY_TIME = 300

type DisclosureFooterProps = {
  content: () => JSX.Element | null
  testId?: string
}

export const DisclosuresFooter = ({
  content,
  testId,
}: DisclosureFooterProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const disclosuresRef = useRef<null | HTMLDivElement>(null)
  const { getRemoteString } = useRemoteStrings()

  const DisclosureContentComponent = content

  const toggleOpen = async () => {
    if (isOpen) {
      setIsOpen(false)
    } else {
      setIsOpen(true)
      await new Promise((resolve) =>
        setTimeout(resolve, DISCLOSURES_OPEN_DELAY_TIME),
      )
      disclosuresRef?.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
      })
    }
  }
  const footerTestId = testId ? `${testId}_dropdown` : 'footer_dropdown'
  return (
    <FooterSection ref={disclosuresRef}>
      <OuterContainer>
        <Footer />
        <DisclosuresDropdown onClick={toggleOpen} data-testid={footerTestId}>
          {getRemoteString({ key: 'action_feed.footer.disclosure.title' })}
          <Arrow icon={AcornsIcon.Icon.UpChevron} isOpen={isOpen} />
        </DisclosuresDropdown>
      </OuterContainer>
      <Disclosures data-testid={testId} isOpen={isOpen}>
        <DisclosureContentComponent />
      </Disclosures>
    </FooterSection>
  )
}
